import React, { act, useEffect, useState } from "react";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import MyBetsSingle from "./MyBetsSingle";
import { useTabIndicator } from "./useTabIndicator";
import { AnimatePresence, motion } from "framer-motion";
import moment from "moment";
import { betCheckObj } from "../Utils/Toast";
import { isMobile } from "react-device-detect";
import { t as translate } from "i18next";
const MyBets = () => {
  const showBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.showBets;
  });
  const setShowBets = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowBets;
  });
  const [parly, setParly] = useState([]);
  const [data, setData] = useState([]);
  const [activeParlay, setActiveParlay] = useState([]);
  const [isOpen, setIsOpen] = useState(false); // dropdown visibility
  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);
  const [time, setTime] = useState(true);
  const [activeTab, setActiveTab] = useState("exchange");
  const tabs = [
    { id: "exchange", label: translate("Exchange") },
    { id: "parlay", label: translate("Parlay") },
  ];
  const [matched, setMatched] = useState(true);
  const [active, setActive] = useState([]);
  const [show, setShow] = useState(true);
  const handle = (id) => {
    if (Array.isArray(id)) {
      // If id is an array
      const allExist = id.every((item) => active.includes(item));

      if (allExist) {
        // If all IDs exist → remove them
        setActive(active.filter((res) => !id.includes(res)));
      } else {
        // Otherwise → add missing IDs
        const newIds = id.filter((item) => !active.includes(item));
        setActive([...active, ...newIds]);
      }
    } else {
      // If id is a single value → toggle like before
      if (active.includes(id)) {
        setActive(active.filter((res) => res !== id));
      } else {
        setActive([...active, id]);
      }
    }
  };

  const getId = (array) => {
    return array?.flatMap((res) => {
      // Collect all possible lists dynamically
      const lists = [
        "betList",
        "sessionBetList",
        "sportBookBetList",
        "bookmakerList",
      ];

      // Extract _ids from each available list
      return lists.flatMap(
        (list) => res?.[list]?.map((item) => item?._id) || [],
      );
    });
  };
  const getCurrentBets = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.mobileCurrentBets,
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users?.results?.length > 0) {
          let find = response_users?.results?.filter((res) => {
            return (
              res?.betList?.length > 0 ||
              res?.bookmakerList?.length > 0 ||
              res?.sessionBetList?.length > 0 ||
              res?.sportBookBetList?.length > 0
            );
          });
          if (find?.length > 0) {
            setData(response_users.results);
            setActive(getId(response_users.results));
          }
        }
      }
    }
  };
  const getParlyBet = async () => {
    const { status, data } = await apiGet(apiPath.getParlyBets);
    if (status == 200) {
      if (data?.success) {
        setParly(data?.results);
        setActiveParlay([]);
      }
    }
  };
  useEffect(() => {
    if (showBets) {
      getCurrentBets();
      getParlyBet();
    }
  }, [showBets]);

  const Tabs = () => {
    return (
      <div className="s-flex s-pl-15px s-h-27px s-text-14px">
        {tabs.map((t) => {
          const isActive = activeTab === t.id;
          return (
            <div
              key={t.id}
              onClick={() => setActiveTab(t.id)}
              className={`s-relative s-h-full s-flex s-items-center s-justify-around s-rounded-t-5px s-w-90px s-text-market-tab-text dark:s-text-global-font-default-dark ${
                isActive
                  ? "s-bg-white dark:s-bg-black-800 s-z-10"
                  : "s-bg-black-400 dark:s-bg-pop-title-bg"
              }`}
            >
              <div className="s-flex s-items-center">
                {/* LEFT corner (mirrored path) */}
                <div className="s-absolute -s-left-4 s-bottom-0 s-w-14px s-h-14px">
                  <svg
                    width="8px"
                    height="8px"
                    viewBox="0 0 8 8"
                    xmlns="http://www.w3.org/2000/svg"
                    className="s-svg-image s-absolute s-right-0 s-bottom-0 s-w-7px s-h-7px"
                  >
                    <g
                      fill="none"
                      fillRule="evenodd"
                      className={
                        isActive
                          ? "s-fill-white dark:s-fill-black-800"
                          : "s-fill-black-400 dark:s-fill-pop-title-bg"
                      }
                    >
                      {/* mirror transform for left corner */}
                      <path
                        d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z"
                        transform="translate(4.000000, 4.000000) scale(-1, 1) translate(-4.000000, -4.000000)"
                      />
                    </g>
                  </svg>
                </div>

                <span className="s-text-15px">{t.label}</span>

                {/* RIGHT corner */}
                <div className="s-absolute s--right-4 s-bottom-0 s-w-14px s-h-14px">
                  <svg
                    width="8px"
                    height="8px"
                    viewBox="0 0 8 8"
                    xmlns="http://www.w3.org/2000/svg"
                    className="s-svg-image s-absolute s-left-0 s-bottom-0 s-w-7px s-h-7px"
                  >
                    <g
                      fill="none"
                      fillRule="evenodd"
                      className={
                        isActive
                          ? "s-fill-white dark:s-fill-black-800"
                          : "s-fill-black-400 dark:s-fill-pop-title-bg"
                      }
                    >
                      <path d="M0,0 C0,4.418278 3.581722,8 8,8 L0,8 L0,0 Z" />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const handleSelect = (option) => {
    setTime(option === "time"); // update selected option
    setIsOpen(false); // close dropdown
    setActive(getId(data));
  };

  const SortFilter = () => {
    return (
      <div className="s-flex s-space-x-2.5">
        <div className="s-relative s-z-20 s-w-133px s-flex s-items-center s-p-7px s-text-11px s-rounded-5px s-sort-Filter s-bg-filter-background-light dark:s-bg-filter-background-dark s-whitespace-nowrap">
          {/* Sort Button */}
          <span className="s-icon-sort s-flex s-items-center s-justify-center s-mr-3px s-text-11px s-text-black-600 dark:s-text-black-500" />

          <button
            className="s-select s-text-left s-w-full s-text-15px"
            value="options"
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <div className="s-flex s-gap-3px s-justify-start s-items-center">
              <div className="s-w-full s-flex s-justify-start s-items-center">
                <span className="s-text-14px s-text-global-font-default-light dark:s-text-global-font-default-dark">
                  {time ? translate("byTime") : translate("byEvent")}
                </span>
              </div>
              <span
                className={`s-icon-arrow-down s-transform s-text-11px s-transition-transform s-origin-center s-duration-300 s-text-sort-by-icon ${
                  isOpen ? "s-rotate-180" : ""
                }`}
              />
            </div>
          </button>

          {/* Dropdown */}
          {isOpen && (
            <div className="s-w-full s-left-0 s-text-15px s-absolute s-top-8 -s-mt-1 s-z-10">
              <div className="s-flex s-flex-col s-sort-Filter s-rounded s-rounded-t-none s-whitespace-nowrap s-bg-filter-background-light dark:s-bg-filter-background-dark">
                <p
                  className="s-item s-flex s-items-center s-pt-5px s-pb-7px s-px-6 s-cursor-pointer s-text-global-font-default-light dark:s-text-global-font-default-dark"
                  onClick={() => handleSelect("time")}
                >
                  <span className="s-item-text s-relative s-text-14px">
                    {translate("byTime")}
                  </span>
                </p>
                <p
                  className="s-item s-flex s-items-center s-pt-5px s-pb-7px s-px-6 s-cursor-pointer s-text-global-font-default-light dark:s-text-global-font-default-dark"
                  onClick={() => handleSelect("event")}
                >
                  <span className="s-item-text s-relative s-text-14px">
                    {translate("byEvent")}
                  </span>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const variants = {
    hidden: { y: 750 }, // start from bottom
    visible: { y: 0 }, // slide up into place
    exit: { y: 750 }, // slide up and out (top to bottom)
  };
  return (
    <div
      data-v-e15c02a7
      style={{
        "--66fd57c4": "300",
        "--91910bda": "100%  - 5.857142857142857rem",
      }}
    >
      <div
        data-v-e15c02a7
        className={`s-my-bets-mask s-top-0 s-left-0 s-w-full s-h-full s-bg-black/50 s-backdrop-blur-[2px] s-fixed ${
          isMobile ? "s-w-full" : "s-w-desktop"
        }`}
        style={showBets ? {} : { display: "none" }}
      />
      <AnimatePresence mode="wait">
        {showBets && (
          <motion.div
            data-v-e15c02a7
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={variants}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className={`s-my-bets s-flex s-flex-col s-bottom-0 s-bg-pop-title-bg s-text-pop-title-text s-rounded-t-5px s-fixed ${
              isMobile ? "s-w-full" : "s-w-desktop"
            }`}
            // style={{ display: showBets ? "" : "none" }}
          >
            <div data-v-e15c02a7>
              <div
                data-v-e15c02a7
                className="s-flex s-justify-center s-pt-13px s-pb-12px"
              >
                <p data-v-e15c02a7 className="s-text-17px s-font-bold">
                  {translate("MYBETS")}
                </p>
                <span
                  onClick={() => setShowBets(false)}
                  data-v-e15c02a7
                  className="s-absolute s-right-4 s-icon-close s-cursor-pointer s-text-14px"
                />
              </div>
              <Tabs />
            </div>
            <div
              data-v-e15c02a7
              className="s-bg-pop-title-bg s-text-pop-title-text s-flex-1 s-flex s-flex-col s-overflow-y-scroll s-px-3px s-pb-3px s-rounded-5px"
              isshownewmybets="true"
              isshowdetail="false"
            >
              <div
                ref={containerRef}
                data-v-46e5284f
                className="s-relative s-bg-white dark:s-bg-black-800 s-flex s-justify-around s-px-7px s-py-5px s-text-17px s-font-semibold s-rounded-t-5px"
                style={{
                  "--537223d7": `${indicatorStyle?.width || 164}px`,
                  "--9ffde142": `translateX(${indicatorStyle?.x || 7}px)`,
                }}
              >
                <div
                  onClick={() => {
                    setMatched(true);
                    setActiveIndex(0);
                  }}
                  data-v-46e5284f
                  className={
                    matched
                      ? "s-text-primary dark:s-text-primary-light-200 s-mr-7px s-py-7px s-px-5px s-rounded-3px s-w-full s-text-center s-text-black-600"
                      : "s-py-7px s-px-5px s-rounded-3px s-w-full s-text-center s-text-black-600"
                  }
                >
                  {translate("Matched")}
                </div>
                <div
                  onClick={() => {
                    setMatched(false);
                    setActiveIndex(1);
                  }}
                  data-v-46e5284f
                  className={
                    !matched
                      ? "s-text-primary dark:s-text-primary-light-200 s-py-7px s-px-5px s-rounded-3px s-w-full s-text-center s-text-black-600"
                      : "s-py-7px s-px-5px s-rounded-3px s-w-full s-text-center s-text-black-600"
                  }
                >
                  {translate("Unmatched")}
                </div>
                <motion.div
                  data-v-46e5284f
                  className="tab-indicator s-h-2px s-absolute -s-left-0 s-bottom-0 s-rounded-1.5px s-bg-primary dark:s-bg-primary-light-200"
                  style={{
                    transform: `translateX(${indicatorStyle?.x || 7}px)`,
                    width: `${indicatorStyle?.width || 164}px`,
                  }}
                />
              </div>
              <div
                className={`s-px-2 s-py-7px s-flex s-justify-${
                  activeTab !== "exchange" ? "end" : "between"
                } s-bg-black-100 dark:s-bg-black-900`}
              >
                {activeTab == "exchange" && <SortFilter />}

                <div
                  onClick={() => {
                    if (show) {
                      setShow(false);
                      if (activeTab == "exchange") {
                        setActive([]);
                      } else {
                        setActiveParlay([]);
                      }
                    } else {
                      setShow(true);
                      if (activeTab == "exchange") {
                        setActive(getId(data));
                      } else {
                        setActiveParlay(
                          parly?.map((res) => {
                            return res?._id;
                          }),
                        );
                      }
                    }
                  }}
                  className="s-flex s-gap-3px s-items-center s-p-2 s-text-11px s-rounded-5px s-cursor-pointer s-bg-filter-background-light dark:s-bg-filter-background-dark s-text-global-font-default-light dark:s-text-global-font-default-dark"
                >
                  <span className="s-text-14px">{translate("Collapse")}</span>
                  <span
                    className={`${
                      show ? "s-rotate-180" : ""
                    } s-icon-arrow-double s-text-11px s-transition-transform s-origin-center s-duration-300 s-text-sort-by-icon`}
                  />
                </div>
              </div>
              {activeTab == "exchange" && (
                <section className="s-list-area s-bg-white dark:s-bg-black-800 s-flex-1 s-overflow-y-scroll">
                  {matched && data?.length > 0 ? (
                    data?.map((res) => {
                      return (
                        <MyBetsSingle
                          res={res}
                          active={active}
                          handle={handle}
                          time={time}
                        />
                      );
                    })
                  ) : (
                    <div className="s-flex s-justify-center s-items-center s-py-36">
                      <div className="s-py-6 s-px-7 s-bg-white dark:s-bg-black-800 s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-base s-rounded-5px s-leading-tight s-shadow-2sm">
                        <div
                          alt
                          className="s-icon-empty s-text-40px s-text-black-300 dark:s-opacity-30 s-m-auto s-mb-2.5"
                        />
                        <div>{translate("BetSlipEmpty")}</div>
                      </div>
                    </div>
                  )}
                </section>
              )}
              {activeTab == "parlay" && (
                <section
                  data-v-6feb4f8a
                  className="s-h-full s-bg-white dark:s-bg-black-800 s-p-4px s-overflow-y-scroll"
                >
                  {parly?.length > 0 && matched ? (
                    parly?.map((res) => {
                      return (
                        <section data-v-6feb4f8a className="s-mb-2 first:mt-2">
                          <div className="s-bg-black-300 dark:s-bg-black-700 s-flex s-justify-center s-items-center s-rounded-t-5px">
                            <div className="s-p-2 s-flex s-justify-between s-leading-tight s-text-12px s-w-full">
                              <span>Ref: {res?.matchBetId}</span>
                              <span>
                                {moment(res?.timeInserted).format(
                                  "DD-MM-YYYY HH:MM",
                                )}
                              </span>
                            </div>
                          </div>
                          <section className="s-divide-y s-divide-black-300 dark:s-divide-black-700">
                            <div className="s-border s-border-black-300 dark:s-border-black-700 s-border-b-0 s-divide-y s-divide-black-300 dark:s-divide-black-700">
                              <section className="s-p-2 s-flex s-items-center">
                                <div className="s-shrink-0 s-w-50px s-h-8 s-flex s-mr-2 s-font-bold s-justify-center s-items-center content-between s-bg-black-300 dark:s-bg-black-700 s-rounded-3px s-text-13px s-leading-none">
                                  <div className="dot s-w-4px s-mr-1 s-h-4px s-bg-black-600 s-rounded-full" />
                                  <div className="dot s-w-4px s-mr-1 s-h-4px s-bg-black-600 s-rounded-full" />
                                  <div className="dot s-w-4px s-h-4px s-bg-black-600 s-rounded-full" />
                                </div>
                                <span className="s-flex s-items-center s-text-17px s-font-bold s-break-words">
                                  {res?.bets?.length == 1
                                    ? translate("Single")
                                    : res?.bets?.length == 2
                                      ? translate("Double")
                                      : res?.bets?.length == 3
                                        ? translate("Treble")
                                        : translate("Accumulator")}
                                </span>
                              </section>
                              <section className="s-grid s-grid-cols-3 s-divide-x s-divide-black-300 dark:s-divide-black-700">
                                <div className="s-p-2 s-flex-1">
                                  <div className="s-text-12px">
                                    {translate("AvgOdds")}
                                  </div>
                                  <div className="s-font-bold s-leading-tight s-pt-0.5 s-text-17px">
                                    {res?.bhav}
                                  </div>
                                </div>
                                <div className="s-p-2 s-flex-1">
                                  <div className="s-text-12px">
                                    {translate("StakeBDT")}
                                  </div>
                                  <div className="s-font-bold s-leading-tight s-pt-0.5 s-text-17px">
                                    {res?.amount}
                                  </div>
                                </div>
                                <div className="s-p-2 s-flex-1">
                                  <div className="s-text-12px">
                                    {translate("ProfitBDT")}
                                  </div>
                                  <div className="s-font-bold s-leading-tight s-pt-0.5 s-text-17px">
                                    {res?.profitAmount}
                                  </div>
                                </div>
                              </section>
                              <section className="s-divide-y s-divide-black-300 dark:s-divide-black-700 s-p-2 s-text-12px">
                                <span>
                                  {translate("WillBeKeep")}{" "}
                                  <strong>{translate("keep")}</strong>{" "}
                                  {translate("atInPlay")}
                                </span>
                              </section>
                            </div>
                            {activeParlay?.includes(res?._id) &&
                              res?.bets?.map((item) => {
                                return (
                                  <section className="s-border">
                                    <article>
                                      <div className="s-flex s-justify-center s-items-center s-bg-parlay-betSlip-content-header dark:s-bg-black-900">
                                        <div className="s-p-2 s-leading-tight s-text-12px s-w-full">
                                          <span className="s-whitespace-pre-wrap">
                                            {betCheckObj[item?.eventType]}
                                          </span>
                                          <i className="s-icon-triangle-black-600 s-inline-block" />
                                          <span>
                                            <strong>{item?.matchName}</strong>
                                          </span>
                                          <i className="s-icon-triangle-black-600 s-inline-block" />
                                          <span>{item?.fancyName}</span>
                                        </div>
                                      </div>
                                      <section className="s-bg-parlay-betSlip-content-background-light dark:s-bg-parlay-betSlip-content-background-dark s-p-2 s-flex s-justify-between s-items-center">
                                        <div className="s-flex s-justify-center s-items-center">
                                          <div className="s-shrink-0 s-w-50px s-h-8 s-flex s-mr-2 s-font-bold s-justify-center s-items-center s-content-between s-bg-black-300 dark:s-bg-black-700 s-rounded-3px s-text-13px">
                                            <div className="s-dot s-w-4px s-mr-1 s-h-4px s-bg-black-600 s-rounded-full" />
                                            <div className="s-dot s-w-4px s-mr-1 s-h-4px s-bg-black-600 s-rounded-full" />
                                            <div className="s-dot s-w-4px s-h-4px s-bg-black-600 s-rounded-full" />
                                          </div>
                                          <div className="s-font-bold s-text-17px">
                                            {item?.runnerName}
                                          </div>
                                        </div>
                                        <div className="s-bg-parlay-betInfo-light dark:s-bg-parlay-betInfo-dark dark:s-bg-global-font-default-dark s-text-15px s-px-3 s-py-2 s-rounded-4px s-font-bold">
                                          {item?.bhav}
                                        </div>
                                      </section>
                                    </article>
                                  </section>
                                );
                              })}
                          </section>
                          <footer
                            onClick={() => {
                              if (activeParlay.includes(res?._id)) {
                                setActiveParlay(
                                  activeParlay?.filter((obj) => {
                                    return obj != res?._id;
                                  }),
                                );
                              } else {
                                setActiveParlay([...activeParlay, res?._id]);
                              }
                            }}
                          >
                            <div
                              className={`${
                                activeParlay.includes(res?._id)
                                  ? "s-bg-black-400 dark:s-bg-black-700"
                                  : ""
                              } s-h-2 s-rounded-b-lg s-transition-colors s-duration-500 s-bg-black-300 dark:s-bg-black-700`}
                            />
                            <div
                              className={`${
                                activeParlay.includes(res?._id)
                                  ? "s-bg-black-400"
                                  : ""
                              } s-h-4 s-rounded-b-lg s-w-90px s-mx-auto s-flex s-justify-center s-transition-colors s-duration-500 s-bg-black-300 dark:s-bg-black-700`}
                            >
                              <span
                                className={`${
                                  activeParlay.includes(res?._id)
                                    ? "s-transform s-rotate-180"
                                    : ""
                                } s-icon-arrow-down-sencodary s-text-14px s-relative -s-top-1 s-text-black dark:s-text-global-font-default-dark s-transition-transform s-origin-center s-duration-300`}
                              />
                            </div>
                          </footer>
                        </section>
                      );
                    })
                  ) : (
                    <div
                      data-v-6feb4f8a
                      className="s-flex s-justify-center s-items-center s-py-36 s-h-full"
                    >
                      <div className="s-py-6 s-px-7 s-bg-white dark:s-bg-black-800 s-text-center s-text-global-font-default-light dark:s-text-global-font-default-dark s-text-base s-rounded-5px s-leading-tight s-shadow-2sm">
                        <div
                          alt
                          className="s-icon-empty s-text-40px s-text-black-300 dark:s-opacity-30 s-m-auto s-mb-2.5"
                        />
                        <div>{translate("BetSlipEmpty")}</div>
                      </div>
                    </div>
                  )}
                </section>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MyBets;
